export default __webpack_public_path__ + "static/4-b00a70ea8977769f413142d5ee2c1b78.jpg";